export const REPORT_CHARTS_BY_SLUG = {
  screen: {
    productionSpend: {
      title: 'Production Investment Sources (2024)',
      subtitle: '£5.6B total spend shows heavy dependence on US capital',
      type: 'bar',
      data: [
        { category: 'US Investment', amount: 4816, percentage: 86 },
        { category: 'UK Investment', amount: 784, percentage: 14 }
      ],
      config: {
        layout: 'horizontal',
        xKey: 'category',
        bars: [{ dataKey: 'amount', name: 'Investment (£M)', fill: '#667eea' }],
        yAxisLabel: 'Investment (£M)'
      }
    },
    housingAffordability: {
      title: 'Housing Affordability Pressure in Production Hubs',
      subtitle: 'Ratios above 7.0× indicate severe unaffordability',
      type: 'bar',
      data: [
        { location: 'Buckinghamshire\n(Studios)', ratio: 10.4, threshold: 7.0 },
        { location: 'Entry-Level\nCrew', ratio: 21.0, threshold: 7.0 },
        { location: 'Affordable\nThreshold', ratio: 7.0, threshold: 7.0 }
      ],
      config: {
        layout: 'horizontal',
        xKey: 'location',
        bars: [
          { dataKey: 'ratio', name: 'Current Ratio', fill: '#ff6b6b' },
          { dataKey: 'threshold', name: 'Affordable Threshold', fill: '#96ceb4' }
        ],
        yAxisLabel: 'Affordability Ratio'
      }
    },
    workforcePipeline: {
      title: 'Animation/VFX Workforce Pipeline',
      subtitle: 'Massive structural oversupply: ~6,000 graduates competing for 300-500 roles',
      type: 'bar',
      data: [
        { stage: 'Annual Graduates', value: 6000 },
        { stage: 'Sustainable Roles', value: 400 },
        { stage: 'Oversupply Ratio', value: 15 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'stage',
        bars: [{ dataKey: 'value', name: 'Value', fill: '#4ecdc4' }]
      }
    },
    geographicConcentration: {
      title: 'Production Activity by Region',
      subtitle: 'Heavy concentration in M25 corridor creates systemic vulnerability',
      type: 'pie',
      data: [
        { region: 'M25 Corridor', percentage: 67 },
        { region: 'Bristol', percentage: 12 },
        { region: 'Manchester', percentage: 11 },
        { region: 'Cardiff', percentage: 8 },
        { region: 'Glasgow', percentage: 7 },
        { region: 'Belfast', percentage: 6 }
      ],
      config: {
        nameKey: 'region',
        dataKey: 'percentage'
      }
    },
    hubAffordabilityComparison: {
      title: 'Housing Affordability by Production Hub',
      subtitle: 'Affordability ratios show major divergence across UK screen hubs',
      type: 'bar',
      data: [
        { hub: 'Buckinghamshire', ratio: 10.4 },
        { hub: 'Bristol', ratio: 8.72 },
        { hub: 'Manchester', ratio: 6.4 },
        { hub: 'Cardiff', ratio: 6.0 },
        { hub: 'Glasgow', ratio: 5.3 },
        { hub: 'Belfast', ratio: 4.6 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'hub',
        bars: [{ dataKey: 'ratio', name: 'Affordability Ratio', fill: '#ff6b6b' }]
      }
    },
    landfillTaxTrajectory: {
      title: 'UK Landfill Tax (Standard Rate)',
      subtitle: 'Inflation-linked escalation increases disposal costs for set materials',
      type: 'line',
      data: [
        { year: '2022', rate: 98.6 },
        { year: '2023', rate: 102.1 },
        { year: '2025', rate: 126.15 },
        { year: '2026', rate: 130.75 }
      ],
      config: {
        xKey: 'year',
        lines: [{ dataKey: 'rate', name: '£/tonne', stroke: '#e17055', strokeWidth: 3 }]
      }
    },
    aiQualityConvergence: {
      title: 'Offshore Quality Convergence (Illustrative)',
      subtitle: 'Average offshore output rises toward parity as tooling improves',
      type: 'line',
      data: [
        { year: '2023', offshoreAvg: 60 },
        { year: '2025', offshoreAvg: 75 },
        { year: '2027', offshoreAvg: 90 }
      ],
      config: {
        xKey: 'year',
        lines: [{ dataKey: 'offshoreAvg', name: 'Offshore average vs London (%)', stroke: '#45b7d1', strokeWidth: 3 }]
      }
    },
    aiDisclosureSupport: {
      title: 'UK Audience Support for AI Disclosure',
      subtitle: 'British respondents supporting clear disclosure when AI is used',
      type: 'pie',
      data: [
        { response: 'Support disclosure', percent: 86 },
        { response: 'Oppose/unsure', percent: 14 }
      ],
      config: {
        nameKey: 'response',
        dataKey: 'percent'
      }
    },
    taxReliefByCategory: {
      title: 'UK Creative Sector Tax Relief Claimed (FY 2023-24)',
      subtitle: '£2.4B total relief claimed across categories',
      type: 'bar',
      data: [
        { category: 'HETV', amount: 1100 },
        { category: 'Film', amount: 534 },
        { category: 'Video Games', amount: 327 },
        { category: 'Other', amount: 439 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'category',
        bars: [{ dataKey: 'amount', name: 'Relief (£M)', fill: '#667eea' }]
      }
    },
    vfxTaxReliefRates: {
      title: 'UK AVEC Tax Relief Rates',
      subtitle: 'October 2024 reform dropped proposed AI exclusion; GenAI costs eligible for VFX uplift',
      type: 'bar',
      data: [
        { relief: 'VFX AVEC', grossRate: 39 },
        { relief: 'Film AVEC', grossRate: 34 },
        { relief: 'HETV AVEC', grossRate: 34 },
        { relief: 'Animation', grossRate: 39 },
        { relief: 'IFTC', grossRate: 53 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'relief',
        bars: [{ dataKey: 'grossRate', name: 'Gross rate (%)', fill: '#4ecdc4' }]
      }
    },
    carbonCostTrajectory: {
      title: 'Rising carbon costs reshape production economics',
      subtitle: 'Landfill tax and production carbon penalty trajectory, 2020-2029',
      type: 'area',
      data: [
        { year: 2020, landfill_tax: 94.15, carbon_offset: 15 },
        { year: 2023, landfill_tax: 102.10, carbon_offset: 25 },
        { year: 2025, landfill_tax: 126.15, carbon_offset: 40 },
        { year: 2026, landfill_tax: 130.75, carbon_offset: 50 },
        { year: 2029, landfill_tax: 150, carbon_offset: 75, projected: true }
      ],
      config: {
        xKey: 'year',
        areas: [
          { dataKey: 'landfill_tax', name: 'Landfill Tax (£/tonne)', fill: '#ff6b6b', stroke: '#ff6b6b' },
          { dataKey: 'carbon_offset', name: 'Carbon Offset Cost (£/tonne)', fill: '#4ecdc4', stroke: '#4ecdc4' }
        ]
      }
    },
    commissioningVolatility: {
      title: 'UK Commissioning Whiplash: Boom to Retrenchment',
      subtitle: 'Domestic HETV commissioning £M quarterly, 2020-2025',
      type: 'line',
      data: [
        { quarter: 'Q1 2020', amount: 180, event: 'Pre-pandemic' },
        { quarter: 'Q2 2020', amount: 80, event: 'COVID lockdown' },
        { quarter: 'Q1 2022', amount: 220, event: 'Streaming peak' },
        { quarter: 'Q3 2023', amount: 140, event: 'Strike impact' },
        { quarter: 'Q4 2024', amount: 150, event: 'Retrenchment (-22% YoY)' }
      ],
      config: {
        xKey: 'quarter',
        lines: [{ dataKey: 'amount', name: 'Domestic HETV (£M)', stroke: '#ff6b6b', strokeWidth: 3 }],
        yAxisLabel: '£M'
      }
    },
    regionalMisalignment: {
      title: 'Production Jobs vs. Housing Affordability',
      subtitle: 'Affordability ratio vs production share by UK hub, 2025',
      type: 'bar',
      data: [
        { hub: 'M25/London', affordability: 10.4, share: 67, entryRatio: 21 },
        { hub: 'Bristol', affordability: 8.72, share: 6, entryRatio: 15 },
        { hub: 'Manchester', affordability: 6.4, share: 5, entryRatio: 10 },
        { hub: 'Cardiff', affordability: 6.0, share: 4, entryRatio: 9 },
        { hub: 'Glasgow', affordability: 5.3, share: 3, entryRatio: 8 },
        { hub: 'Belfast', affordability: 4.6, share: 3, entryRatio: 7 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'hub',
        bars: [
          { dataKey: 'affordability', name: 'Affordability Ratio', fill: '#ff6b6b' },
          { dataKey: 'share', name: 'Production Share %', fill: '#4ecdc4' }
        ]
      }
    },
    aiDisplacementTimeline: {
      title: 'AI Quality Convergence vs. UK Jobs',
      subtitle: 'Offshore quality parity vs UK animation/VFX employment, 2022-2029',
      type: 'line',
      data: [
        { year: 2022, quality: 60, vfx_jobs: 10, anim_index: 100 },
        { year: 2023, quality: 65, vfx_jobs: 8.5, anim_index: 85 },
        { year: 2024, quality: 75, vfx_jobs: 6, anim_index: 49 },
        { year: 2025, quality: 80, vfx_jobs: 5.5, anim_index: 45 },
        { year: 2027, quality: 90, vfx_jobs: 4, anim_index: 35, projected: true },
        { year: 2029, quality: 95, vfx_jobs: 3, anim_index: 30, projected: true }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'quality', name: 'Offshore Quality %', stroke: '#4ecdc4', strokeWidth: 3 },
          { dataKey: 'vfx_jobs', name: 'VFX Jobs (k)', stroke: '#ff6b6b', strokeWidth: 2 },
          { dataKey: 'anim_index', name: 'Animation Index', stroke: '#45b7d1', strokeWidth: 2 }
        ]
      }
    }
  },

  music: {
    threeEconomies: {
      title: 'Three Economies: Revenue Share',
      subtitle: 'Live / recorded / ancillary split (illustrative)',
      type: 'pie',
      data: [
        { economy: 'Live Music', revenue: 2800, share: 42 },
        { economy: 'Recorded Music', revenue: 1900, share: 28 },
        { economy: 'Ancillary/Brand', revenue: 2000, share: 30 }
      ],
      config: {
        nameKey: 'economy',
        dataKey: 'share'
      }
    },
    streamingEconomics: {
      title: 'Streaming Economics: Annual Streams Required for Viability',
      subtitle: 'At £0.003/stream, middle-class income requires millions of streams',
      type: 'bar',
      data: [
        { threshold: '£12K/year\n(333K monthly)', streams: 4000000, income: 12000 },
        { threshold: '£25K/year\n(694K monthly)', streams: 8333333, income: 25000 },
        { threshold: '£50K/year\n(1.39M monthly)', streams: 16666667, income: 50000 },
        { threshold: 'UK Median\n(£33K/year)', streams: 11000000, income: 33000 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'threshold',
        bars: [{ dataKey: 'streams', name: 'Annual Streams Required', fill: '#e74c3c' }],
        xAxisType: 'number'
      }
    },
    festivalPriceIncrease: {
      title: 'Festival Ticket Prices vs Inflation (2019-2024)',
      subtitle: '156% price increase vs 32% inflation: unsustainable divergence',
      type: 'line',
      data: [
        { year: '2019', price: 100, inflation: 100 },
        { year: '2020', price: 108, inflation: 102 },
        { year: '2021', price: 125, inflation: 107 },
        { year: '2022', price: 165, inflation: 117 },
        { year: '2023', price: 220, inflation: 127 },
        { year: '2024', price: 256, inflation: 132 }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'price', name: 'Festival Prices', stroke: '#e74c3c', strokeWidth: 3 },
          { dataKey: 'inflation', name: 'UK Inflation', stroke: '#4ecdc4', strokeWidth: 3 }
        ],
        yAxisLabel: 'Index (2019 = 100)'
      }
    },
    venueClosures: {
      title: 'Grassroots Venue Closures (2020-2023)',
      subtitle: '125 venues lost to gentrification in urban centers',
      type: 'bar',
      data: [
        { period: '2020', closures: 28 },
        { period: '2021', closures: 45 },
        { period: '2022', closures: 32 },
        { period: '2023', closures: 20 }
      ],
      config: {
        xKey: 'period',
        bars: [{ dataKey: 'closures', name: 'Closures', fill: '#ff6b6b' }],
        yAxisLabel: 'Venue Closures'
      }
    },
    touringCostBreakdown: {
      title: 'Mid-Tier Touring Cost Breakdown',
      subtitle: 'Illustrative cost split for a mid-tier tour',
      type: 'bar',
      data: [
        { category: 'Transport', cost: 28000, percentage: 35 },
        { category: 'Accommodation', cost: 20000, percentage: 25 },
        { category: 'Equipment', cost: 16000, percentage: 20 },
        { category: 'Crew/Labour', cost: 12000, percentage: 15 },
        { category: 'Marketing', cost: 4000, percentage: 5 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'category',
        bars: [{ dataKey: 'cost', name: 'Cost (£)', fill: '#e74c3c' }],
        xAxisType: 'number'
      }
    }
  },

  games: {
    ukGamesRevenueSeries: {
      title: 'UK Games Market Revenue (2012-2024)',
      subtitle: 'First market contraction since 2019 (£7.63B in 2024)',
      type: 'line',
      data: [
        { year: 2012, revenue_bn: 3.27 },
        { year: 2013, revenue_bn: 3.48 },
        { year: 2014, revenue_bn: 3.94 },
        { year: 2015, revenue_bn: 4.19 },
        { year: 2016, revenue_bn: 4.33 },
        { year: 2017, revenue_bn: 5.11 },
        { year: 2018, revenue_bn: 5.70 },
        { year: 2019, revenue_bn: 5.39 },
        { year: 2020, revenue_bn: 7.00 },
        { year: 2021, revenue_bn: 7.47 },
        { year: 2022, revenue_bn: 7.77 },
        { year: 2023, revenue_bn: 7.82 },
        { year: 2024, revenue_bn: 7.63 }
      ],
      config: {
        xKey: 'year',
        lines: [{ dataKey: 'revenue_bn', name: 'Revenue (£BN)', stroke: '#ff6b6b', strokeWidth: 3 }]
      }
    },
    platformRevenueMix2024: {
      title: 'UK Games Software Revenue by Platform (2024)',
      subtitle: 'Mobile and console dominate market share',
      type: 'pie',
      data: [
        { platform: 'Digital Console', revenue_m: 2446, percent: 47.6 },
        { platform: 'Mobile', revenue_m: 1725, percent: 33.6 },
        { platform: 'Digital PC', revenue_m: 647, percent: 12.6 },
        { platform: 'Physical/Boxed', revenue_m: 322, percent: 6.3 }
      ],
      config: {
        nameKey: 'platform',
        dataKey: 'percent'
      }
    },
    regionalEmploymentDistribution2024: {
      title: 'UK Games Development Employment by Region (2024)',
      subtitle: 'TIGA: 80% of development occurs outside London',
      type: 'bar',
      data: [
        { region: 'London', percent: 23.0 },
        { region: 'South East', percent: 18.7 },
        { region: 'North West', percent: 12.3 },
        { region: 'West Midlands', percent: 9.9 },
        { region: 'Scotland', percent: 9.3 },
        { region: 'North East', percent: 6.3 },
        { region: 'East of England', percent: 5.9 },
        { region: 'Yorkshire', percent: 5.8 },
        { region: 'East Midlands', percent: 4.5 },
        { region: 'South West', percent: 2.7 },
        { region: 'NI/Wales', percent: 1.2 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'region',
        bars: [{ dataKey: 'percent', name: 'Workforce Share %', fill: '#4ecdc4' }]
      }
    },
    wageGapComparisonByRole: {
      title: 'UK Salary Comparison: Games vs Tech/Fintech (2024)',
      subtitle: 'Wage gap has widened to 35-50% for senior roles',
      type: 'bar',
      data: [
        { role: 'Senior Designer', games: 50, fintech: 107.5 },
        { role: 'Senior Engineer', games: 63, fintech: 105 },
        { role: 'Senior Producer', games: 52.7, fintech: 109.1 },
        { role: 'Junior Dev', games: 28, fintech: 45 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'role',
        bars: [
          { dataKey: 'games', name: 'Games (£K)', fill: '#ff6b6b' },
          { dataKey: 'fintech', name: 'Fintech (£K)', fill: '#45b7d1' }
        ]
      }
    },
    crunchHoursDistribution: {
      title: 'Developer Working Hours: Regular vs Crunch',
      subtitle: 'Significant crunch impact: 30% work 60+ hours',
      type: 'bar',
      data: [
        { bracket: '40-44 hrs', regular: 49, crunch: 0 },
        { bracket: '45-49 hrs', regular: 35, crunch: 28 },
        { bracket: '50-59 hrs', regular: 9, crunch: 31 },
        { bracket: '60-69 hrs', regular: 2, crunch: 21 },
        { bracket: '70+ hrs', regular: 0, crunch: 16 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'bracket',
        bars: [
          { dataKey: 'regular', name: 'Regular %', fill: '#96ceb4' },
          { dataKey: 'crunch', name: 'Crunch %', fill: '#ff6b6b' }
        ]
      }
    },
    studioFoundingVsClosures: {
      title: 'UK Games Studio Dynamics (2023-2024)',
      subtitle: 'Record closures (248) lead to first net decline in studios',
      type: 'bar',
      data: [
        { period: '2021-2023 (Founded)', value: 251 },
        { period: '2023-2024 (Founded)', value: 166 },
        { period: '2023-2024 (Closed)', value: 248 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'period',
        bars: [{ dataKey: 'value', name: 'Studio Count', fill: '#667eea' }]
      }
    },
    wageComparison: {
      title: 'Wage Gap Evolution: Games vs Adjacent Sectors',
      subtitle: 'Senior role compensation comparison, 2019-2024',
      type: 'bar',
      data: [
        { role: 'Senior\nDesigner', games: 65, fintech: 107.5, gap: 42.5 },
        { role: 'Senior\nEngineer', games: 72.5, tech: 120, gap: 47.5 },
        { role: 'Lead\nProgrammer', games: 80, tech: 130, gap: 50 },
        { role: 'Creative\nDirector', games: 85, tech: 140, gap: 55 }
      ],
      config: {
        xKey: 'role',
        bars: [
          { dataKey: 'games', name: 'Games Industry', fill: '#ff6b6b' },
          { dataKey: 'fintech', name: 'Fintech/Tech', fill: '#4ecdc4' }
        ],
        yAxisLabel: 'Annual Salary (£K)'
      }
    },
    workforceDistribution: {
      title: 'Geographic Distribution of UK Games Studios',
      subtitle: 'Regional workforce concentration, 2024',
      type: 'pie',
      data: [
        { region: 'London/Southeast', percentage: 42 },
        { region: 'Northwest', percentage: 18 },
        { region: 'Scotland', percentage: 12 },
        { region: 'Southwest', percentage: 9 },
        { region: 'Yorkshire', percentage: 8 },
        { region: 'Northeast', percentage: 6 },
        { region: 'Other', percentage: 5 }
      ],
      config: {
        nameKey: 'region',
        dataKey: 'percentage'
      }
    },
    talentFlow: {
      title: 'Talent Exit Rate vs Wage Gap Correlation',
      subtitle: 'Wage disparity and exit rate move together',
      type: 'line',
      data: [
        { year: '2019', exitRate: 18, wageGap: 15 },
        { year: '2020', exitRate: 22, wageGap: 20 },
        { year: '2021', exitRate: 28, wageGap: 25 },
        { year: '2022', exitRate: 35, wageGap: 30 },
        { year: '2023', exitRate: 40, wageGap: 35 },
        { year: '2024', exitRate: 43, wageGap: 40 }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'exitRate', name: 'Exit Rate %', stroke: '#ff6b6b', strokeWidth: 3, yAxisId: 'left' },
          { dataKey: 'wageGap', name: 'Wage Gap %', stroke: '#4ecdc4', strokeWidth: 3, yAxisId: 'right' }
        ]
      }
    },
    fundingConsolidation: {
      title: 'Funding Consolidation Trend',
      subtitle: 'Deal count vs average deal size, 2019-2024',
      type: 'bar',
      data: [
        { year: '2019', deals: 127, avgSize: 3.8 },
        { year: '2020', deals: 105, avgSize: 4.2 },
        { year: '2021', deals: 92, avgSize: 5.1 },
        { year: '2022', deals: 81, avgSize: 5.8 },
        { year: '2023', deals: 74, avgSize: 6.5 },
        { year: '2024', deals: 68, avgSize: 7.5 }
      ],
      config: {
        xKey: 'year',
        bars: [
          { dataKey: 'deals', name: 'Number of Deals', fill: '#ff6b6b', yAxisId: 'left' },
          { dataKey: 'avgSize', name: 'Average Deal Size (£M)', fill: '#4ecdc4', yAxisId: 'right' }
        ]
      }
    }
  },

  fashion: {
    complianceCost: {
      title: 'Digital Product Passport Compliance Cost Bands',
      subtitle: 'Annual platform fees dominate cost structure; per-passport pricing exists in some systems',
      type: 'bar',
      data: [
        { companySize: 'Small brands', annualFeeEur: 10000 },
        { companySize: 'Medium companies', annualFeeEur: 70000 },
        { companySize: 'Large enterprises', annualFeeEur: 500000 },
        { companySize: 'Per-passport models', annualFeeEur: 1 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'companySize',
        bars: [{ dataKey: 'annualFeeEur', name: 'Cost (€)', fill: '#ff6b6b' }],
        xAxisType: 'number'
      }
    },
    woolPriceTrajectory: {
      title: 'British Wool Auction Price Trajectory',
      subtitle: '5-year trend showing COVID crash recovery to nine-year high (£1.21/kg)',
      type: 'line',
      data: [
        { year: '2020', price: 0.90 },
        { year: '2021', price: 0.50 },
        { year: '2022', price: 0.65 },
        { year: '2023', price: 0.80 },
        { year: '2024', price: 1.00 },
        { year: '2025', price: 1.21 }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'price', name: '£/kg', stroke: '#4ecdc4', strokeWidth: 3 }
        ]
      }
    },
    fashionEmployment: {
      title: 'UK Fashion Employment Breakdown (2025)',
      subtitle: 'Retail dominance hides manufacturing and wholesale roles',
      type: 'bar',
      data: [
        { segment: 'Manufacturing', employees: 88000 },
        { segment: 'Wholesale', employees: 62000 },
        { segment: 'Retail', employees: 413000 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'segment',
        bars: [{ dataKey: 'employees', name: 'Employees', fill: '#667eea' }]
      }
    },
    repairVsResaleDisplacement: {
      title: 'Displacement Rates: Repair vs Resale',
      subtitle: 'WRAP 2025: Repairs displace more new purchases (82.2%) than resale (64.6%)',
      type: 'bar',
      data: [
        { channel: 'Repair', displacement: 82.2, co2_saved_kg: 16 },
        { channel: 'Resale', displacement: 64.6, co2_saved_kg: 10 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'channel',
        bars: [{ dataKey: 'displacement', name: 'Displacement %', fill: '#4ecdc4' }]
      }
    },
    resaleMarketShare: {
      title: 'UK Resale Platform Market Share (C2C)',
      subtitle: 'Vinted dominance in the UK second-hand market',
      type: 'pie',
      data: [
        { platform: 'Vinted', share: 95, users: '18M' },
        { platform: 'Depop', share: 3, users: '5M' },
        { platform: 'Other', share: 2, users: 'N/A' }
      ],
      config: {
        nameKey: 'platform',
        dataKey: 'share'
      }
    },
    dppRegulatoryTimeline: {
      title: 'DPP Regulatory Timeline (EU vs UK)',
      subtitle: 'EU enforcement in mid-2027; UK implementation expected 18-24 months later',
      type: 'bar',
      data: [
        { milestone: 'ESPR Entry (EU)', year: 2024 },
        { milestone: 'Textile Registry (EU)', year: 2026 },
        { milestone: 'EU Enforcement', year: 2027 },
        { milestone: 'UK Equivalent (Est)', year: 2029 }
      ],
      config: {
        layout: 'horizontal',
        xKey: 'milestone',
        bars: [{ dataKey: 'year', name: 'Year', fill: '#ff6b6b' }]
      }
    },
    vintageAppreciation: {
      title: 'Vintage Fashion Appreciation vs Inflation',
      subtitle: 'Archive piece value growth creating asset class dynamics',
      type: 'line',
      data: [
        { year: '2019', vintage: 100, inflation: 100, spread: 0 },
        { year: '2020', vintage: 115, inflation: 101, spread: 14 },
        { year: '2021', vintage: 132, inflation: 105, spread: 27 },
        { year: '2022', vintage: 152, inflation: 109, spread: 43 },
        { year: '2023', vintage: 175, inflation: 113, spread: 62 },
        { year: '2024', vintage: 201, inflation: 117, spread: 84 }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'vintage', name: 'Vintage', stroke: '#ff6b6b', strokeWidth: 2 },
          { dataKey: 'inflation', name: 'Inflation', stroke: '#4ecdc4', strokeWidth: 2 }
        ]
      }
    },
    repairEconomy: {
      title: 'Repair Economy Supply-Demand Gap',
      subtitle: 'Consumer demand vs skilled repairer supply by service type',
      type: 'bar',
      data: [
        { service: 'Zip\nReplacement', demand: 85, supply: 45, gap: 40 },
        { service: 'Hem\nAdjustment', demand: 92, supply: 60, gap: 32 },
        { service: 'Seam\nRepair', demand: 78, supply: 50, gap: 28 },
        { service: 'Button\nReplace', demand: 95, supply: 75, gap: 20 },
        { service: 'Custom\nAlteration', demand: 65, supply: 35, gap: 30 }
      ],
      config: {
        xKey: 'service',
        bars: [
          { dataKey: 'demand', name: 'Demand', fill: '#ff6b6b' },
          { dataKey: 'supply', name: 'Supply', fill: '#4ecdc4' }
        ]
      }
    },
    marketTiers: {
      title: 'Fashion Market Tier Stratification & 2029 Viability',
      subtitle: 'How price tiers diverge under regulatory and supply chain pressure',
      type: 'bar',
      data: [
        { tier: 'Luxury (Heritage Vertical)', percentage: 8, viable2029: 'Yes' },
        { tier: 'Premium (£80-£200)', percentage: 15, viable2029: 'Yes' },
        { tier: 'Mid-Market (£25-£80)', percentage: 35, viable2029: 'At Risk' },
        { tier: 'Fast Fashion (£10-£25)', percentage: 28, viable2029: 'Marginal' },
        { tier: 'Ultra-Fast (<£10)', percentage: 14, viable2029: 'No' }
      ],
      config: {
        layout: 'vertical',
        xKey: 'tier',
        bars: [{ dataKey: 'percentage', name: 'Market Share %', fill: '#45b7d1' }],
        xAxisType: 'number'
      }
    },
    fashionEmploymentBreakdown: {
      title: 'UK Fashion Employment Breakdown',
      subtitle: 'Direct employment split across manufacturing, wholesale, and retail',
      type: 'bar',
      data: [
        { segment: 'Manufacturing', employees: 88000 },
        { segment: 'Wholesale', employees: 62000 },
        { segment: 'Retail', employees: 413000 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'segment',
        bars: [{ dataKey: 'employees', name: 'Employees', fill: '#667eea' }],
        xAxisType: 'number'
      }
    },
    repairVsResaleDisplacement: {
      title: 'Displacement Rates: Repair vs Resale',
      subtitle: 'WRAP 2025: repairs displace more new purchases than resale',
      type: 'bar',
      data: [
        { channel: 'Repair', displacement: 82.2 },
        { channel: 'Resale', displacement: 64.6 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'channel',
        bars: [{ dataKey: 'displacement', name: 'Displacement (%)', fill: '#4ecdc4' }],
        xAxisType: 'number'
      }
    },
    resalePlatformConcentration: {
      title: 'UK Resale Platform Concentration (Illustrative)',
      subtitle: 'Vinted dominates UK C2C resale; other platforms remain smaller',
      type: 'pie',
      data: [
        { platform: 'Vinted', share: 95 },
        { platform: 'Other', share: 5 }
      ],
      config: {
        nameKey: 'platform',
        dataKey: 'share'
      }
    },
    dppTimeline: {
      title: 'Digital Product Passport Milestones (EU Textiles)',
      subtitle: 'Confirmed enforcement trajectory through mid-2027',
      type: 'bar',
      data: [
        { milestone: 'ESPR in force', year: 2024 },
        { milestone: 'Textiles delegated act (expected)', year: 2026 },
        { milestone: 'EU digital registry operational', year: 2026 },
        { milestone: 'Textile DPP enforceable', year: 2027 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'milestone',
        bars: [{ dataKey: 'year', name: 'Year', fill: '#ff6b6b' }],
        xAxisType: 'number'
      }
    }
  }
  ,

  advertising: {
    aiAdoptionMonetization: {
      title: 'AI Adoption vs Business Impact',
      subtitle: 'Widespread adoption, minimal monetization (2023-2025)',
      type: 'composed',
      data: [
        { year: 'Early 2023', adoption: 15, kpiImprovement: 8 },
        { year: 'Q2 2024', adoption: 41, kpiImprovement: 12 },
        { year: 'Early 2025', adoption: 85, kpiImprovement: 15, context: '85% adoption, 48-60% KPI improvement' }
      ],
      config: {
        xKey: 'year',
        bars: [{ dataKey: 'adoption', name: 'AI Adoption %', fill: '#4ecdc4' }],
        lines: [{ dataKey: 'kpiImprovement', name: 'KPI/Monetization %', stroke: '#ff6b6b', strokeWidth: 3 }]
      }
    },
    adFraudEscalation: {
      title: 'Global Digital Ad Fraud Losses',
      subtitle: 'Escalating losses reaching $172B by 2028',
      type: 'area',
      data: [
        { year: 2023, losses: 37.7 },
        { year: 2024, losses: 37.7 },
        { year: 2025, losses: 41.4, context: 'Verified 2025 data' },
        { year: 2026, losses: 65, projected: true },
        { year: 2027, losses: 95, projected: true },
        { year: 2028, losses: 172, projected: true }
      ],
      config: {
        xKey: 'year',
        areas: [{ dataKey: 'losses', name: 'Fraud Losses ($B)', fill: '#ff6b6b', stroke: '#ff6b6b' }]
      }
    },
    walledGardenConcentration: {
      title: 'Walled Garden Market Concentration',
      subtitle: 'Google, Meta, Amazon control 55.8% of global spend',
      type: 'area',
      data: [
        { year: 2020, google: 26, meta: 18, amazon: 4, other: 52 },
        { year: 2021, google: 27, meta: 19, amazon: 5, other: 49 },
        { year: 2023, google: 28, meta: 19, amazon: 6.9, other: 46.1 },
        { year: 2024, google: 29, meta: 20, amazon: 7.5, other: 43.5 },
        { year: 2025, google: 29.5, meta: 18.5, amazon: 7.8, other: 44.2, context: 'Combined 55.8%' },
        { year: 2026, google: 30, meta: 18, amazon: 8.2, other: 43.8, projected: true }
      ],
      config: {
        xKey: 'year',
        stack: true,
        areas: [
          { dataKey: 'google', name: 'Google', fill: '#4285F4' },
          { dataKey: 'meta', name: 'Meta', fill: '#0668E1' },
          { dataKey: 'amazon', name: 'Amazon', fill: '#FF9900' },
          { dataKey: 'other', name: 'Open Web / Other', fill: '#96ceb4' }
        ]
      }
    },
    ukAdSpendChannelMix: {
      title: 'UK Advertising Spend by Channel',
      subtitle: 'Shift to experiential and direct marketing (£M)',
      type: 'bar',
      data: [
        { year: '2024 Q4', mainMedia: 18500, directMarketing: 8200, events: 4100, pr: 3500 },
        { year: '2025 Forecast', mainMedia: 17700, directMarketing: 8660, events: 4870, pr: 3740 }
      ],
      config: {
        xKey: 'year',
        bars: [
          { dataKey: 'mainMedia', name: 'Main Media', fill: '#ff6b6b' },
          { dataKey: 'directMarketing', name: 'Direct Marketing', fill: '#4ecdc4' },
          { dataKey: 'events', name: 'Events/Experiential', fill: '#45b7d1' },
          { dataKey: 'pr', name: 'PR', fill: '#96ceb4' }
        ]
      }
    },
    employmentPipeline: {
      title: 'Employment Pipeline',
      subtitle: 'Graduates vs sustainable roles vs actual hires',
      type: 'bar',
      data: [
        { stage: 'Annual Graduates\n(Creative Programs)', value: 2400, context: 'Current UK supply' },
        { stage: 'Sustainable Roles\n(Creative-Adjacent)', value: 1200, context: 'Realistic demand' },
        { stage: 'Actual New Hires\n2025', value: 450, context: 'Actual placements' },
        { stage: 'Junior Role\nVacancies', value: -1950, context: 'Unmet supply' }
      ],
      config: {
        layout: 'vertical',
        xKey: 'stage',
        bars: [{ dataKey: 'value', name: 'Value', fill: '#ff6b6b' }],
        xAxisType: 'number'
      }
    },
    cpmViabilityScatter: {
      title: 'CPM Budget Viability Scatter',
      subtitle: 'Campaign size vs verified reach affordability',
      type: 'scatter',
      data: [
        { budget: 50, verifiedCost: 56, unverifiedEffective: 28.5, viable: false, label: 'Excluded' },
        { budget: 75, verifiedCost: 62, unverifiedEffective: 30, viable: false, label: 'Excluded' },
        { budget: 100, verifiedCost: 70, unverifiedEffective: 32, viable: false, label: 'Marginal' },
        { budget: 150, verifiedCost: 80, unverifiedEffective: 33, viable: true, label: 'Accessible' },
        { budget: 200, verifiedCost: 90, unverifiedEffective: 35, viable: true, label: 'Accessible' },
        { budget: 300, verifiedCost: 100, unverifiedEffective: 37, viable: true, label: 'Comfortable' },
        { budget: 500, verifiedCost: 120, unverifiedEffective: 40, viable: true, label: 'Comfortable' },
        { budget: 1000, verifiedCost: 150, unverifiedEffective: 45, viable: true, label: 'Highly Viable' },
        { budget: 5000, verifiedCost: 220, unverifiedEffective: 50, viable: true, label: 'Highly Viable' }
      ],
      config: {
        xKey: 'budget',
        yKey: 'verifiedCost',
        name: 'Campaigns',
        fill: '#4ecdc4'
      }
    },
    sentimentMoralHazard: {
      title: 'Prevention vs Insurance Premium',
      subtitle: 'Moral hazard: insurance can be cheaper than prevention',
      type: 'composed',
      data: [
        { brandScale: 'Small\n(£10M spend)', preventionCost: 800, insurancePremium: 250 },
        { brandScale: 'Mid\n(£50M spend)', preventionCost: 2000, insurancePremium: 450 },
        { brandScale: 'Large\n(£200M spend)', preventionCost: 5000, insurancePremium: 750 },
        { brandScale: 'Global\n(£1B+ spend)', preventionCost: 12000, insurancePremium: 1200 }
      ],
      config: {
        xKey: 'brandScale',
        bars: [
          { dataKey: 'preventionCost', name: 'Prevention Investment (£K)', fill: '#ff6b6b' },
          { dataKey: 'insurancePremium', name: 'Insurance Premium (£K)', fill: '#4ecdc4' }
        ]
      }
    }
  },

  ai: {
    aiFundingConcentration: {
      title: 'AI Funding Concentration',
      subtitle: '60% of global VC to $500M+ deals (2025)',
      type: 'area',
      data: [
        { year: 2023, foundationModels: 25, lateStage: 35, earlyStage: 30, seedPreSeed: 18 },
        { year: 2024, foundationModels: 45, lateStage: 38, earlyStage: 22, seedPreSeed: 9 },
        { year: 2025, foundationModels: 80, lateStage: 60, earlyStage: 45, seedPreSeed: 17, context: 'Megarounds dominate' }
      ],
      config: {
        xKey: 'year',
        stack: true,
        areas: [
          { dataKey: 'foundationModels', name: 'Foundation Models ($500M+)', fill: '#667eea' },
          { dataKey: 'lateStage', name: 'Late-Stage ($100M-$500M)', fill: '#4ecdc4' },
          { dataKey: 'earlyStage', name: 'Early-Stage ($10M-$100M)', fill: '#45b7d1' },
          { dataKey: 'seedPreSeed', name: 'Seed/Pre-Seed (<$10M)', fill: '#96ceb4' }
        ]
      }
    },
    portfolioFraudEscalation: {
      title: 'AI-Enabled Hiring Fraud Acceleration',
      subtitle: '59% suspect fraud, 25% fake by 2028 (Gartner)',
      type: 'line',
      data: [
        { year: 2023, suspicion: 35, usage: 45, fakePrediction: 5 },
        { year: 2024, suspicion: 48, usage: 60, fakePrediction: 10 },
        { year: 2025, suspicion: 59, usage: 75, fakePrediction: 15, context: '59% suspicion' },
        { year: 2028, suspicion: 70, usage: 88, fakePrediction: 25, projected: true }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'suspicion', name: 'Hiring Manager Suspicion %', stroke: '#ff6b6b', strokeWidth: 3 },
          { dataKey: 'usage', name: 'Candidate AI Usage %', stroke: '#4ecdc4', strokeWidth: 2 },
          { dataKey: 'fakePrediction', name: 'Fake Applicant Forecast %', stroke: '#45b7d1', strokeWidth: 2, strokeDasharray: '5 5' }
        ]
      }
    },
    modelCollapseContamination: {
      title: 'Web Contamination & Model Collapse Risk',
      subtitle: '74% of new pages contain AI text (April 2025)',
      type: 'composed',
      data: [
        { period: 'Pre-2022', syntheticShare: 0, modelPerformance: 100 },
        { period: 'May 2024', syntheticShare: 25, modelPerformance: 95 },
        { period: 'July 2025', syntheticShare: 74.2, modelPerformance: 85, context: '74.2% contamination' },
        { period: '2026 Proj', syntheticShare: 85, modelPerformance: 70, projected: true }
      ],
      config: {
        xKey: 'period',
        areas: [{ dataKey: 'syntheticShare', name: 'Synthetic Web Share %', fill: '#ff6b6b', opacity: 0.3 }],
        lines: [{ dataKey: 'modelPerformance', name: 'Performance Index', stroke: '#4ecdc4', strokeWidth: 3, yAxisId: 'right' }]
      }
    },
    contentLicensingDeals: {
      title: 'Content Licensing Deal Economics',
      subtitle: '18+ publisher deals, Anthropic $1.5B settlement (2025)',
      type: 'bar',
      data: [
        { year: '2023', deals: 3, totalValue: 0.5 },
        { year: '2024', deals: 12, totalValue: 2.5 },
        { year: '2025', deals: 18, totalValue: 3.0, context: 'Anthropic $1.5B ($3K/book)' }
      ],
      config: {
        xKey: 'year',
        bars: [
          { dataKey: 'deals', name: 'Number of Deals', fill: '#4ecdc4' },
          { dataKey: 'totalValue', name: 'Total Deal Value (£B)', fill: '#45b7d1' }
        ]
      }
    },
    deepfakeSyntheticIdentityFraud: {
      title: 'Synthetic Identity & Deepfake Fraud Risk',
      subtitle: 'AI-generated fake IDs pass KYC checks for £15',
      type: 'bar',
      data: [
        { threat: 'Synthetic ID Cost', value: 15 },
        { threat: 'KYC Bypass Rate (%)', value: 42 },
        { threat: 'Deepfake Detection Rate (%)', value: 68 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'threat',
        bars: [{ dataKey: 'value', name: 'Risk Level', fill: '#ff6b6b' }]
      }
    },
    aiSectorEmploymentRevenue: {
      title: 'UK AI Sector Employment & Revenue',
      subtitle: '86,139 workers, £23.9B revenue (2024)',
      type: 'bar',
      data: [
        { metric: 'Revenue (£B)', value: 23.9 },
        { metric: 'Employment (K)', value: 86.1 },
        { metric: 'GVA (£B)', value: 2.2 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'metric',
        bars: [{ dataKey: 'value', name: 'Value', fill: '#667eea' }]
      }
    },
    jobMarketDisplacement: {
      title: 'Job Market Displacement',
      subtitle: 'AI-vulnerable role vacancies fell 38% in 2024',
      type: 'composed',
      data: [
        { period: 'May 2022', vacancies: 100, youthUnemployment: 10.9 },
        { period: 'Early 2024', vacancies: 62, youthUnemployment: 12.5 },
        { period: 'May 2025', vacancies: 43, youthUnemployment: 14.3 }
      ],
      config: {
        xKey: 'period',
        bars: [{ dataKey: 'vacancies', name: 'Job Vacancies Index', fill: '#ff6b6b' }],
        lines: [{ dataKey: 'youthUnemployment', name: 'Youth Unemployment %', stroke: '#45b7d1', strokeWidth: 3, yAxisId: 'right' }]
      }
    }
  },

  creators: {
    creatorIncomeInequality: {
      title: 'UK Creator Income Inequality',
      subtitle: '4% can live on creator income alone (2025)',
      type: 'bar',
      data: [
        { group: 'Mega Influencer', annualIncome: 132600 },
        { group: 'Average Creator', annualIncome: 36000 },
        { group: 'Micro Influencer', annualIncome: 12252 }
      ],
      config: {
        xKey: 'group',
        bars: [{ dataKey: 'annualIncome', name: 'Annual Income (£)', fill: '#ff6b6b' }]
      }
    },
    youtubeGdpJobsGrowth: {
      title: 'YouTube Creator Economy Growth',
      subtitle: 'GDP and Job contribution (Oxford Economics 2025)',
      type: 'composed',
      data: [
        { year: 2022, gdp: 1.4, jobs: 29000 },
        { year: 2024, gdp: 2.2, jobs: 45000 }
      ],
      config: {
        xKey: 'year',
        bars: [{ dataKey: 'jobs', name: 'FTE Jobs', fill: '#4ecdc4' }],
        lines: [{ dataKey: 'gdp', name: 'GDP (£B)', stroke: '#ff6b6b', strokeWidth: 3, yAxisId: 'right' }]
      }
    },
    creatorSideHustle: {
      title: 'Side Hustle Reality',
      subtitle: '65% of UK creators have other full-time work',
      type: 'pie',
      data: [
        { name: 'Full-time Elsewhere', value: 65 },
        { name: 'Full-time Creator', value: 27 },
        { name: 'Part-time Other', value: 8 }
      ],
      config: {
        nameKey: 'name',
        dataKey: 'value'
      }
    },
    creatorBurnoutCrisis: {
      title: 'Creator Mental Health Crisis',
      subtitle: '52% experienced burnout (July 2025)',
      type: 'bar',
      data: [
        { metric: 'Burnout', value: 52 },
        { metric: 'Considering Quitting', value: 37 },
        { metric: 'Creative Fatigue', value: 40 },
        { metric: 'Financial Instability', value: 55 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'metric',
        bars: [{ dataKey: 'value', name: '% of Creators', fill: '#a29bfe' }],
        xAxisType: 'number'
      }
    },
    creatorPopulation: {
      title: 'UK Creator Population',
      subtitle: '25% of UK population identify as creators (Adobe 2025)',
      type: 'bar',
      data: [
        { metric: 'Total Creators (M)', value: 16.6 },
        { metric: 'New since 2020 (M)', value: 8.0 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'metric',
        bars: [{ dataKey: 'value', name: 'Millions', fill: '#667eea' }],
        xAxisType: 'number'
      }
    },
    creatorEconomyValue: {
      title: 'UK Creator Market Value',
      subtitle: 'Influencer marketing vs direct ad spend (£B)',
      type: 'bar',
      data: [
        { category: 'Influencer Market', value: 2.36 },
        { category: 'Direct Ad Spend', value: 0.93 }
      ],
      config: {
        xKey: 'category',
        bars: [{ dataKey: 'value', name: 'Value (£B)', fill: '#45b7d1' }]
      }
    },
    inhousingPenetration: {
      title: 'Inhousing Penetration',
      subtitle: 'Independent creators decline as salaried creators rise',
      type: 'line',
      data: [
        { year: 2023, independentCreators: 88, salariedCreators: 12, accountOwnership: 95 },
        { year: 2024, independentCreators: 85, salariedCreators: 15, accountOwnership: 92 },
        { year: 2025, independentCreators: 82, salariedCreators: 18, accountOwnership: 88 },
        { year: 2026, independentCreators: 75, salariedCreators: 25, accountOwnership: 75 },
        { year: 2027, independentCreators: 65, salariedCreators: 35, accountOwnership: 60 },
        { year: 2029, independentCreators: 60, salariedCreators: 40, accountOwnership: 45 }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'independentCreators', name: 'Independent Creators %', stroke: '#ff6b6b', strokeWidth: 2 },
          { dataKey: 'salariedCreators', name: 'Salaried Creators %', stroke: '#4ecdc4', strokeWidth: 2 },
          { dataKey: 'accountOwnership', name: 'Account Ownership %', stroke: '#45b7d1', strokeWidth: 2 }
        ]
      }
    },
    sentimentDemonetization: {
      title: 'Sentiment vs Monetisation',
      subtitle: 'Negative sentiment correlates with demonetisation cliff',
      type: 'scatter',
      data: [
        { sentiment: 90, monetization: 100, contentType: 'Positive' },
        { sentiment: 70, monetization: 100, contentType: 'Neutral' },
        { sentiment: 50, monetization: 100, contentType: 'Critical' },
        { sentiment: 35, monetization: 40, contentType: 'Negative' },
        { sentiment: 20, monetization: 5, contentType: 'Rage Bait' }
      ],
      config: {
        xKey: 'sentiment',
        yKey: 'monetization',
        name: 'Content Types',
        fill: '#4ecdc4'
      }
    }
  },

  education: {
    pensionReversal: {
      title: 'USS Pension: Deficit to Surplus',
      subtitle: 'USS moved to £9.2B surplus (March 2024)',
      type: 'line',
      data: [
        { year: '2021', value: -17.9, label: 'Peak Deficit' },
        { year: '2022', value: -2.9, label: 'Improvement' },
        { year: '2023', value: 7.4, label: 'First Surplus' },
        { year: '2024', value: 9.2, label: '£9.2B Surplus' }
      ],
      config: {
        xKey: 'year',
        lines: [{ dataKey: 'value', name: 'Balance (£B)', stroke: '#4ecdc4', strokeWidth: 3 }]
      }
    },
    internationalVisaCollapse: {
      title: 'International Student Visa Collapse',
      subtitle: 'Impact of dependent ban and fee increases (2024)',
      type: 'bar',
      data: [
        { group: 'Overall', change: -14 },
        { group: 'Nigeria', change: -55 },
        { group: 'Bangladesh', change: -41 },
        { group: 'India', change: -26 },
        { group: 'Dependents', change: -85 }
      ],
      config: {
        xKey: 'group',
        bars: [{ dataKey: 'change', name: 'YoY Change %', fill: '#ff6b6b' }]
      }
    },
    universityFinancialCrisis: {
      title: 'Universities in Financial Distress',
      subtitle: '72% projected deficits by 2025/26 (OfS)',
      type: 'bar',
      data: [
        { year: '2024/25', percent: 43, label: 'Forecasting Deficit' },
        { year: '2025/26', percent: 72, label: 'Projected Deficit' }
      ],
      config: {
        xKey: 'year',
        bars: [{ dataKey: 'percent', name: '% of Universities', fill: '#ff6b6b' }]
      }
    },
    degreeCostReality: {
      title: 'True Cost of Creative Degrees',
      subtitle: '£90-100K all-in (tuition + living)',
      type: 'bar',
      data: [
        { location: 'Outside London', tuition: 28605, living: 63378 },
        { location: 'London', tuition: 28605, living: 74700 }
      ],
      config: {
        xKey: 'location',
        stack: true,
        bars: [
          { dataKey: 'tuition', name: 'Tuition (£)', fill: '#45b7d1' },
          { dataKey: 'living', name: 'Living (£)', fill: '#ff6b6b' }
        ]
      }
    },
    academicCasualization: {
      title: 'Academic Casualization',
      subtitle: '132,075 staff on insecure contracts (HESA 2023/24)',
      type: 'bar',
      data: [
        { category: 'Fixed-term', count: 71715 },
        { category: 'Atypical', count: 60360 }
      ],
      config: {
        xKey: 'category',
        bars: [{ dataKey: 'count', name: 'Staff Count', fill: '#a29bfe' }]
      }
    },
    graduateEmploymentRatios: {
      title: 'Creative Graduates vs Jobs',
      subtitle: 'Selected discipline oversupply ratios',
      type: 'bar',
      data: [
        { discipline: 'Animation', graduates: 800, jobs: 800 },
        { discipline: 'Drama', graduates: 2400, jobs: 288 },
        { discipline: 'Film', graduates: 23800, jobs: 84000, note: 'Industry Total' }
      ],
      config: {
        xKey: 'discipline',
        bars: [
          { dataKey: 'graduates', name: 'Graduates/Enrolled', fill: '#ff6b6b' },
          { dataKey: 'jobs', name: 'Available Jobs/Total', fill: '#4ecdc4' }
        ]
      }
    },
    tLevelScaleGap: {
      title: 'T-Level Enrollment vs Demand',
      subtitle: 'Massive gap in vocational provision',
      type: 'bar',
      data: [
        { group: 'Current Enrollment', value: 2790 },
        { group: 'Estimated Demand', value: 30000 }
      ],
      config: {
        xKey: 'group',
        bars: [{ dataKey: 'value', name: 'Students', fill: '#667eea' }]
      }
    },
    classStratification: {
      title: 'Class Stratification in Creative Education',
      subtitle: 'Participation by income quintile (2019-2029)',
      type: 'line',
      data: [
        { year: '2019', lowest: 42, highest: 28 },
        { year: '2024', lowest: 31, highest: 36 },
        { year: '2029', lowest: 18, highest: 40, projected: true }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'lowest', name: 'Lowest Quintile %', stroke: '#ff6b6b', strokeWidth: 3 },
          { dataKey: 'highest', name: 'Highest Quintile %', stroke: '#4ecdc4', strokeWidth: 3 }
        ]
      }
    }
  },

  performing: {
    touringCosts: {
      title: 'Tour Cost Bands vs Fuel Price',
      subtitle: 'Mid-tier 15-date tour cost range and diesel price',
      type: 'composed',
      data: [
        { year: 2019, diesel: 1.15, crossing: 0, tourCostLow: 7000, tourCostHigh: 9000 },
        { year: 2021, diesel: 1.33, crossing: 60, tourCostLow: 9000, tourCostHigh: 12000 },
        { year: 2024, diesel: 1.82, crossing: 140, tourCostLow: 12000, tourCostHigh: 18000 },
        { year: 2029, diesel: 2.15, crossing: 140, tourCostLow: 14000, tourCostHigh: 21000 }
      ],
      config: {
        xKey: 'year',
        bars: [
          { dataKey: 'tourCostLow', name: 'Low Est (£)', fill: '#ff6b6b' },
          { dataKey: 'tourCostHigh', name: 'High Est (£)', fill: '#ff6b6b', opacity: 0.6 }
        ],
        lines: [
          { dataKey: 'diesel', name: 'Diesel (£/L)', stroke: '#4ecdc4', strokeWidth: 3, yAxisId: 'right' }
        ]
      }
    },
    insurancePremium: {
      title: 'Insurance Premium as % of Gross',
      subtitle: 'Outdoor event coverage affordability',
      type: 'area',
      data: [
        { year: 2022, premiumPctLow: 3, premiumPctHigh: 5 },
        { year: 2024, premiumPctLow: 8, premiumPctHigh: 15 },
        { year: 2029, premiumPctLow: 4, premiumPctHigh: 7 }
      ],
      config: {
        xKey: 'year',
        areas: [
          { dataKey: 'premiumPctHigh', name: 'Upper Bound %', fill: '#4ecdc4', stroke: '#4ecdc4' },
          { dataKey: 'premiumPctLow', name: 'Lower Bound %', fill: '#96ceb4', stroke: '#96ceb4' }
        ]
      }
    },
    hologramVsLive: {
      title: 'Marginal Cost vs Cancellation Risk',
      subtitle: 'Illustrative comparison (cost in £K)',
      type: 'composed',
      data: [
        { category: 'Hologram (marginal)', cost: 22, risk: 0.2 },
        { category: 'Living artist', cost: 215, risk: 10 }
      ],
      config: {
        xKey: 'category',
        bars: [{ dataKey: 'cost', name: 'Marginal Cost (£K)', fill: '#45b7d1' }],
        lines: [{ dataKey: 'risk', name: 'Cancellation Risk %', stroke: '#ff6b6b', strokeWidth: 3, yAxisId: 'right' }]
      }
    },
    payToPlayVenues: {
      title: 'Venues Reported Practising Pay-to-Play',
      subtitle: 'Illustrative trajectory based on documented counts',
      type: 'line',
      data: [
        { year: 2019, venues: 45 },
        { year: 2024, venues: 210 },
        { year: 2029, venues: 320 }
      ],
      config: {
        xKey: 'year',
        lines: [{ dataKey: 'venues', name: 'Venue Count', stroke: '#ff6b6b', strokeWidth: 3 }]
      }
    },
    phoneFreePremium: {
      title: 'Ticket Uplift for Phone-Free Access',
      subtitle: 'Equal-price choice vs premium-tier monetisation',
      type: 'bar',
      data: [
        { model: 'Equal price (target)', upliftPct: 0 },
        { model: 'Observed premium band', upliftPct: 20 },
        { model: 'High premium risk case', upliftPct: 44 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'model',
        bars: [{ dataKey: 'upliftPct', name: 'Price Uplift %', fill: '#45b7d1' }]
      }
    },
    warehouseMigration: {
      title: 'Indoor Shift Pressure (Illustrative)',
      subtitle: 'Uninsured exposure and indoor-format adoption as climate volatility rises',
      type: 'area',
      data: [
        { year: 2024, premiumPctLow: 8, premiumPctHigh: 15 },
        { year: 2027, premiumPctLow: 10, premiumPctHigh: 18 },
        { year: 2029, premiumPctLow: 12, premiumPctHigh: 20 }
      ],
      config: {
        xKey: 'year',
        areas: [
          { dataKey: 'premiumPctHigh', name: 'Pressure Index', fill: '#4ecdc4', stroke: '#4ecdc4' }
        ]
      }
    }
  },

  social: {
    botPrevalence: {
      title: 'Bot Prevalence by Platform (2025)',
      subtitle: 'Estimated percentage of automated accounts',
      type: 'bar',
      data: [
        { platform: 'Twitter/X', percentage: 20, range: [15, 25], confidence: 'MEDIUM' },
        { platform: 'Instagram', percentage: 12, range: [10, 14], confidence: 'MEDIUM' },
        { platform: 'Reddit', percentage: 12.5, range: [10, 15], confidence: 'LOW' },
        { platform: 'Facebook', percentage: 4, range: [3, 5], confidence: 'MEDIUM' }
      ],
      config: {
        layout: 'horizontal',
        xKey: 'platform',
        bars: [{ dataKey: 'percentage', name: 'Bot Estimate %', fill: '#ff6b6b' }]
      }
    },
    digitalDivide: {
      title: 'Digital Divide by Income Quintile (2025)',
      subtitle: 'Internet access rates across UK socioeconomic bands',
      type: 'bar',
      data: [
        { quintile: 'Bottom (DE)', access: 82, spend: 26 },
        { quintile: '2nd (C2)', access: 93, spend: 26 },
        { quintile: '3rd (C1)', access: 96, spend: 26 },
        { quintile: 'Top (AB)', access: 99, spend: 26 }
      ],
      config: {
        xKey: 'quintile',
        bars: [
          { dataKey: 'access', name: 'Access Rate %', fill: '#45b7d1' }
        ]
      }
    },
    telegramRevenue: {
      title: 'Telegram Admin Revenue Streams',
      subtitle: 'Composition of channel monetization (2025)',
      type: 'pie',
      data: [
        { name: 'Direct Sponsorships', value: 42.5 },
        { name: 'Ad Revenue Sharing', value: 22.5 },
        { name: 'Product Sales', value: 22.5 },
        { name: 'Subscriptions', value: 6.5 },
        { name: 'Tips/Crypto', value: 6 }
      ],
      config: {
        nameKey: 'name',
        dataKey: 'value'
      }
    },
    monetizationTimeline: {
      title: 'Platform Monetization Milestones',
      subtitle: 'Evolution of ads and creator programs',
      type: 'bar',
      data: [
        { platform: 'Meta', year: 2007, event: 'Ads Launch' },
        { platform: 'YouTube', year: 2007, event: 'Partner Program' },
        { platform: 'Twitter/X', year: 2010, event: 'Ads Launch' },
        { platform: 'TikTok', year: 2019, event: 'Ads Launch' },
        { platform: 'Telegram', year: 2022, event: 'Premium Launch' }
      ],
      config: {
        layout: 'vertical',
        xKey: 'platform',
        bars: [{ dataKey: 'year', name: 'Launch Year', fill: '#667eea' }]
      }
    },
    alternativePlatformGrowth: {
      title: 'Bluesky Registered User Growth (2024-2025)',
      subtitle: 'Growth in millions of users',
      type: 'line',
      data: [
        { date: 'Feb 2024', users: 3 },
        { date: 'Aug 2024', users: 6 },
        { date: 'Nov 2024', users: 20 },
        { date: 'Jan 2025', users: 30 },
        { date: 'Oct 2025', users: 40.2 }
      ],
      config: {
        xKey: 'date',
        lines: [{ dataKey: 'users', name: 'Million Users', stroke: '#4ecdc4', strokeWidth: 3 }]
      }
    }
  },

  infrastructure: {
    enterpriseAiMaturityGap: {
      title: 'Enterprise AI Maturity Gap (2025)',
      subtitle: 'Drop-off from broad adoption to actual financial value realization',
      type: 'bar',
      data: [
        { stage: 'Using AI', percent: 88 },
        { stage: 'Scaled Enterprise-wide', percent: 31 },
        { stage: '5%+ EBIT Impact', percent: 6 },
        { stage: 'Rollout "Mature"', percent: 1 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'stage',
        bars: [{ dataKey: 'percent', name: 'Organizations %', fill: '#667eea' }]
      }
    },
    aiRoiExpectationGap: {
      title: 'AI ROI: Expectations vs. Reality',
      subtitle: '66% of CFOs expect returns within 2 years; reality is often 2-4 years',
      type: 'bar',
      data: [
        { metric: 'Expect ROI < 2yrs', value: 66 },
        { metric: 'Realize value today', value: 14 },
        { metric: 'Payback < 1yr', value: 6 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'metric',
        bars: [{ dataKey: 'value', name: 'CFOs/Projects %', fill: '#ff6b6b' }]
      }
    },
    gridCapacityDivergence: {
      title: 'UK Data Center Demand vs. Grid Capacity',
      subtitle: 'Unsustainable divergence in power growth trajectories',
      type: 'line',
      data: [
        { year: 2024, dc_demand: 41, grid_capacity: 100 },
        { year: 2025, dc_demand: 125, grid_capacity: 104 },
        { year: 2030, dc_demand: 350, grid_capacity: 125, projected: true }
      ],
      config: {
        xKey: 'year',
        lines: [
          { dataKey: 'dc_demand', name: 'Grid Queue/Demand (GW)', stroke: '#ff6b6b', strokeWidth: 3 },
          { dataKey: 'grid_capacity', name: 'Grid Capacity Index', stroke: '#4ecdc4', strokeWidth: 2 }
        ]
      }
    },
    seriesASuccessDecline: {
      title: 'Series A Success Rate Decline',
      subtitle: "AI startups face a significant 'Series A Crunch' in 2025",
      type: 'line',
      data: [
        { year: 2018, rate: 30.6 },
        { year: 2022, rate: 15.4 },
        { year: 2025, rate: 21.5, projected: true }
      ],
      config: {
        xKey: 'year',
        lines: [{ dataKey: 'rate', name: 'Success Rate %', stroke: '#e17055', strokeWidth: 3 }]
      }
    },
    shadowAiAdoptionFunnel: {
      title: 'Shadow AI Adoption & Governance Gap',
      subtitle: 'Telemetry reveals widespread unauthorized AI usage',
      type: 'bar',
      data: [
        { metric: 'Shadow AI Activity', percent: 90 },
        { metric: 'Personal AI Use', percent: 68 },
        { metric: 'Hide AI Use', percent: 57 },
        { metric: 'Official Policy', percent: 40 },
        { metric: 'Adequate Governance', percent: 20 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'metric',
        bars: [{ dataKey: 'percent', name: 'Companies/Staff %', fill: '#ff6b6b' }]
      }
    },
    unionAiResistanceSentiment: {
      title: 'Union AI Resistance Sentiment (2025)',
      subtitle: 'Creative labor unified against unauthorized AI adoption',
      type: 'bar',
      data: [
        { union: 'Equity (Refuse Scans)', percent: 99.6 },
        { union: 'WGGB (Expect Income Loss)', percent: 65 },
        { union: 'WGGB (Support AI Fees)', percent: 81 },
        { union: 'Bectu (Negative Impact)', percent: 54 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'union',
        bars: [{ dataKey: 'percent', name: 'Agreement %', fill: '#45b7d1' }]
      }
    },
    offshoreCostQualityMatrix: {
      title: 'Animation Production: UK vs. Offshore (2025)',
      subtitle: 'Cost per minute vs. quality parity index',
      type: 'bar',
      data: [
        { region: 'UK', cost_k: 6, quality: 100 },
        { region: 'Philippines', cost_k: 2.5, quality: 85 },
        { region: 'India', cost_k: 2.2, quality: 80 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'region',
        bars: [
          { dataKey: 'cost_k', name: 'Cost (£K/min)', fill: '#ff6b6b' },
          { dataKey: 'quality', name: 'Quality Index %', fill: '#4ecdc4' }
        ]
      }
    },
    employmentUtilizationCrisis: {
      title: 'Creative Industries Employment Utilization',
      subtitle: 'Underemployment crisis documented in late 2025',
      type: 'bar',
      data: [
        { metric: 'Workforce Utilization', percent: 60 },
        { metric: 'Freelancers finding work hard', percent: 65 },
        { metric: 'Self-Employed Ratio', percent: 29 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'metric',
        bars: [{ dataKey: 'percent', name: 'Percentage %', fill: '#667eea' }]
      }
    }
  },


  craft: {
    heritageCraftSkillsExtinction: {
      title: 'Heritage Craft Skills Extinction',
      subtitle: '216 endangered crafts, median practitioner age 68',
      type: 'composed',
      data: [
        { age: '70+', percent: 35 },
        { age: '60-69', percent: 30 },
        { age: '50-59', percent: 20 },
        { age: '40-49', percent: 10 },
        { age: 'Under 40', percent: 5 }
      ],
      config: {
        xKey: 'age',
        bars: [{ dataKey: 'percent', name: 'Practitioners %', fill: '#ff6b6b' }]
      }
    },
    rightToRepairLegislation: {
      title: 'UK Right to Repair Status',
      subtitle: 'Gap between EU Directive and UK 2021 Regulations',
      type: 'bar',
      data: [
        { category: 'Smartphones', eu: 100, uk: 0 },
        { category: 'Tablets', eu: 100, uk: 0 },
        { category: 'White Goods', eu: 100, uk: 100 },
        { category: 'TVs', eu: 100, uk: 100 }
      ],
      config: {
        xKey: 'category',
        bars: [
          { dataKey: 'eu', name: 'EU (2026)', fill: '#4285F4' },
          { dataKey: 'uk', name: 'UK (Current)', fill: '#96ceb4' }
        ]
      }
    },
    repairCafeNetworkGrowth: {
      title: 'Repair Cafe Network Expansion',
      subtitle: 'Current scale vs 2029 Target',
      type: 'bar',
      data: [
        { metric: 'Cafes', current: 220, target: 480 },
        { metric: 'Annual Events', current: 18000, target: 68000 }
      ],
      config: {
        xKey: 'metric',
        bars: [
          { dataKey: 'current', name: '2025 Current', fill: '#4ecdc4' },
          { dataKey: 'target', name: '2029 Target', fill: '#45b7d1' }
        ]
      }
    },
    ukCraftSectorEmploymentGVA: {
      title: 'UK Craft Sector Scale',
      subtitle: '£3.4B Revenue, ~150,000 makers',
      type: 'bar',
      data: [
        { metric: 'GVA (£B)', value: 3.4 },
        { metric: 'Employment (K)', value: 150 },
        { metric: 'Exports (£B)', value: 5 }
      ],
      config: {
        layout: 'vertical',
        xKey: 'metric',
        bars: [{ dataKey: 'value', name: 'Value', fill: '#667eea' }],
        xAxisType: 'number'
      }
    },
    selfEmploymentSideHustleEconomy: {
      title: 'Side Hustle by Generation',
      subtitle: '43% of UK adults have a side hustle (2024)',
      type: 'bar',
      data: [
        { gen: 'Gen Z', percent: 68 },
        { gen: 'Millennials', percent: 55 },
        { gen: 'Gen X', percent: 42 },
        { gen: 'Boomers', percent: 28 },
        { gen: 'UK Average', percent: 43 }
      ],
      config: {
        xKey: 'gen',
        bars: [{ dataKey: 'percent', name: 'Side Hustle %', fill: '#ff6b6b' }]
      }
    },
    aiCraftGenerationMarketShare: {
      title: 'Etsy UK AI Listing Growth',
      subtitle: 'AI-generated products as % of total listings',
      type: 'line',
      data: [
        { year: 2022, percent: 2 },
        { year: 2023, percent: 8 },
        { year: 2024, percent: 18 },
        { year: 2025, percent: 25, projected: true }
      ],
      config: {
        xKey: 'year',
        lines: [{ dataKey: 'percent', name: 'AI Share %', stroke: '#4ecdc4', strokeWidth: 3 }]
      }
    }
  }
};
